import "./Blog.module.css";
import MainNavigation from "@/reusable_sections/Header";
import CompleteHomeComfort from "./sections/CompleteHomeComfort";
import LatestWisdom from "./sections/LatestWisdom";
import Footer from "@/reusable_sections/Footer";
export default function BlogPage() {
  return <div>
      <MainNavigation />
      <CompleteHomeComfort />
      <LatestWisdom />
      <Footer />
    </div>;
}